import { httpPost } from "../services/http";


export const crud = (name, state, action, fn, type = 'array') => {

	if (!fn) {
		fn = () => state;
	}

	switch (action.type) {
		case name + '_update':
			if (type === 'object') {
				return { ...state, ...action.data };
			} else {
				const index = state.findIndex(el => {
					return el._id === action.data._id;
				});
				state[index] = action.data;
				return [...state];
			}
		case name + '_error':
			if (type === 'object') {
				return { ...state, ...action.data };
			} else {
				const index = state.findIndex(el => {
					return el._id === action.data._id;
				});
				state[index].error = action.data;
				return [...state];
			}
		case name + '_add':
			return [...state, ...action.data];
		case name + '_addToStart':
			return [...action.data, ...state];
		case name + '_delete':
			return [...state.filter(el => el._id !== action.data._id)];
		default:
			return fn();
	}
};

export const update = (name, action, data) => dispatch => {
	dispatch({
		type: 'loader',
		data: true
	});

	httpPost(action, data)
		.then(data => {
			if (data.ok) {
				dispatch({
					type: name + '_update',
					data
				});
			} else {
				let d = {};
				if (!data.error) {
					d.error = data.error
				} else {
					d = data;
				}
				dispatch({
					type: name + '_error',
					data: d
				});
			}

			dispatch({
				type: 'loader',
				data: false
			});
		});
};